import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { authenticate } from '../auth';

export const Signin = () => {
  let dispatch = useDispatch();
  const onClickAuth = useCallback(() => authenticate(dispatch), []);

  return (
    <div className="container">
      <div className="row justify-content-md-center">
        <div className="col-12">
          <div className="py-5 my-5 text-center main-color">
            <h1 className="display-5 fw-bold">STACKS DEGENS</h1>
            <div className="second-color">
              <p className="lead mb-0 pt-4">LET'S GET STARTED</p>
              <hr className="divider" />
              {/* // TODO(andrei) is user select auto important really important */}
              <a
                href="#"
                className="text-decoration-none"
                style={{ outlineWidth: '0px !important', userSelect: 'auto !important' as any }}
                onClick={onClickAuth}
              >
                <p className="mb-0 lead"> SIGN IN </p>
              </a>
              <br />
            </div>
            <div></div>
            <p className="mb-4 pb-4 lead"> </p>
          </div>
        </div>
      </div>
    </div>
  );
};
